/**
 * A push on its own page: deep-linkable, which is what makes "watch this push" a thing a
 * colleague can be sent, and what the e2e suite asserts on.
 */
import { Link } from '@tanstack/react-router'
import { PushTracker } from '@/components/PushTracker'

export function PushScreen({ pushId }: { pushId: string }) {
  return (
    <div className="flex flex-col gap-4">
      <div>
        <nav aria-label="Breadcrumb" className="flex items-center gap-2 text-[12px] text-mist-400">
          <Link to="/" className="underline decoration-dotted hover:text-mist-200">
            Console
          </Link>
          <span aria-hidden="true">/</span>
          <span className="text-mist-300">Push</span>
        </nav>
        <h1 className="mt-1 text-[22px] leading-8 font-semibold tracking-tight text-mist-100">
          Push {pushId.slice(0, 8)}
        </h1>
        <p className="mt-0.5 max-w-2xl text-[12.5px] text-mist-400">
          The state machine below is the real one: draft → preflight → dry run → lease → publishing pages
          → pushing → live (paused). Success in v1 means the campaigns exist and are paused; AdForge never
          leaves a campaign serving.
        </p>
      </div>
      <PushTracker pushId={pushId} />
    </div>
  )
}
